import React from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "../../configs/constants/routes";
import LoggedInLayout from "../Layout/LoggedInLayout";
import NotFoundComponent from "../Shared/NotFoundComponent/NotFoundComponent";
import { useAuthStore } from "../../stores/auth.store";

/** `bare` renders the page without the logged-in chrome (sidebar/header) — for full-screen editors opened in their own tab. */
const PrivateRoute: React.FC<{ children: React.ReactNode; bare?: boolean }> = ({ children, bare }) => {
	const authStore = useAuthStore();

	const navigate = useNavigate();

	if (!authStore.isLoggedIn) {
		navigate(routes.LOGIN, { replace: true });
	}

	if (!authStore.initiated || !authStore.isLoggedIn) return <NotFoundComponent />;

	if (bare) return <>{children}</>;

	return <LoggedInLayout>{children}</LoggedInLayout>;
};

export default PrivateRoute;
